import {
  createFileRoute,
  Navigate,
  Outlet,
  redirect,
  useRouterState
} from '@tanstack/react-router';
import { Head } from '@_/components';
import { useStores } from '#src/state/StoreContext.tsx';

export const Route = createFileRoute('/{-$locale}/_auth')({
  component: RouteComponent,
  beforeLoad: async ({ context, location }) => {
    const { useAuthStore } = context;

    if (!(await useAuthStore.getState().checkSession())) {
      throw redirect({
        to: '/{-$locale}/login',
        params: prev => ({ locale: prev.locale }),
        search: {
          redirect: location.href
        }
      });
    }
  },
  ssr: false
});

function RouteComponent() {
  const { useAuthStore } = useStores();
  const isAuthenticated = useAuthStore(state => !!state.session);
  const locationHref = useRouterState({ select: state => state.location.href });

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/{-$locale}/login"
        params={prev => ({ locale: prev.locale })}
        search={{
          redirect: locationHref
        }}
      />
    );
  }

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <Outlet />
    </>
  );
}
